<template>
  <div class="card shadow" style="border-radius: 12px 12px 0px 0px !important">
    <div class="card-header background-MINT" style="
        padding: 5px 16px !important;
        border-radius: 12px 12px 0 0 !important;">
      <TimeCalculation :cargo="cargo" />
    </div>
    <div class="card-body pb-0">
      <div v-if="cargo.freeCall == true" class="chip chip-outline chip-warning mb-3">
          <span class="chip-label">رایگان تماس بگیر</span>
      </div>
      <div class="theme-search-results-item _mb-10 _b-n theme-search-results-item-rounded theme-search-results-item">
        <div class="theme-search-results-item-preview">
          <div class="row" data-gutter="20">
            <div class="col-md-10">
              <div class="theme-search-results-item-flight-sections">
                <div class="theme-search-results-item-flight-section">
                  <div class="row row-no-gutter row-eq-height">
                    <div class="col-md-10">
                      <div class="theme-search-results-item-flight-section-item">
                        <div class="row">
                          <div class="col-md-3">
                            <div class="theme-search-results-item-flight-section-path">
                              <div class="theme-search-results-item-flight-section-path-fly-time">
                                <p v-if="cargo.priceBased == 'به صورت صافی' || cargo.priceBased == 'بصورت صافی'">
                                  {{ formatPrice(cargo.suggestedPrice) }} تومان
                                </p>
                                <p v-if="cargo.priceBased == 'توافقی'">
                                  <strong class="title-cargo-large">توافقی</strong>
                                </p>
                                <p v-if="cargo.priceBased == 'به ازای هر تن'">
                                  به ازای هر تن:
                                  {{ formatPrice(cargo.suggestedPrice) }}
                                </p>
                              </div>
                              <div class="col-md-6">
                                <div class="theme-search-results-item-flight-section-path-line-start">
                                  <span class="from-to">
                                    {{ splitedListTo[0] }}
                                  </span>
                                  <!-- <div><ion-icon name="chevron-forward-outline"></ion-icon></div> -->
                                  <div class="theme-search-results-item-flight-section-path-line-title f-mobile">
                                    {{ splitedListTo[1] }}
                                  </div>

                                </div>
                                <div class="theme-search-results-item-flight-section-path-line"><span
                                    class="arrow-line"><ion-icon name="arrow-forward-outline"></ion-icon></span></div>
                                <div class="theme-search-results-item-flight-section-path-line-end">
                                  <span class="from-to">{{ splitedListFrom[0] }}</span>
                                  <!-- <div class="theme-search-results-item-flight-section-path-line-dot"></div> -->
                                  <div class="theme-search-results-item-flight-section-path-line-title f-mobile">
                                    {{ splitedListFrom[1] }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <h5 class="text-center" v-if="cargo.distanceCity != 0">{{ roundNumber(cargo.distanceCity) + ' کیلومتر ' }}</h5>
                </div>
              </div>
            </div>
            <div class="">
              <div class="theme-search-results-item-book">
                <div class="theme-search-results-item-price">
                  <div class="theme-search-results-item-price">
                    <!-- <p v-if="cargo.priceBased == 'به صورت صافی'">
                      {{ formatPrice(cargo.suggestedPrice) }} تومان
                    </p>
                    <p v-if="cargo.priceBased == 'توافقی'">
                      قیمت: <strong>توافقی</strong>
                    </p>
                    <p v-if="cargo.priceBased == 'به ازای هر تن'">
                      به ازای هر تن:
                      {{ formatPrice(cargo.suggestedPrice) }}
                    </p> -->
                    <p class="title-cargo-large" v-if="cargo.title !== 'بدون عنوان'">
                      {{ cargo.title }}
                    </p>
                    <!-- <p>
                      <span
                        class="badge background-WINTER text-TEAL"
                        v-for="fleet in fleets"
                        :key="fleet.id">
                        {{ fleet.title }}
                      </span>
                    </p> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="m-2 text-center">
      <router-link :to="{ name: 'cargoShow', params: { load: cargo.id } }" 
        class="btn background-ORANGE text-light btn-block btn-lg theme-search-results-item-price-btn">
        {{ driver_call == null ? 'جزئیات | تماس' : 'جزئیات | تماس گرفته اید' }}
      </router-link>
      
      <!-- <button type="button" style="
          display: none;
          box-shadow: 5px 5px 5px #aac4cd !important;
          border-radius: 18px;"
          class="btn background-ORANGE text-light btn-block btn-lg theme-search-results-item-price-btn"
          data-bs-toggle="modal"
          :id="cargo.id"
          :data-bs-target="'#ModalBasic_' + cargo.id">
        جزئیات | تماس
      </button>
      <button v-if="loading == true" type="button"
        style="box-shadow: 5px 5px 5px #aac4cd !important; border-radius: 18px"
        class="btn background-ORANGE text-light btn-block btn-lg theme-search-results-item-price-btn"
        v-on:click.prevent="getData(cargo.id)">
        {{ driver_call == null ? 'جزئیات | تماس' : 'جزئیات | تماس گرفته اید' }}
      </button>
      <button v-else class="btn background-ORANGE text-light btn-block btn-lg theme-search-results-item-price-btn"
        type="button" disabled="">
        <span class="spinner-border spinner-border-sm me-05" role="status" aria-hidden="true"></span>
        درحال بارگذاری ...
      </button> -->
    </div>
  </div>
</template>

<script>
import moment from "moment";
import axios from "axios";
import delivery_methods from "@/delivery_methods";
import { reactive, ref } from "vue";
import TimeCalculation from "./TimeCalculation.vue";
export default {
  props: {
    cargo: Object,
  },

  computed: {
    splitedListFrom() {
      var names = this.cargo.fromCity;
      var nameArr = names.split(",");
      return nameArr;
    },

    splitedListTo() {
      var names = this.cargo.toCity;
      var nameArr = names.split(",");
      return nameArr;
    }
  },
  data() {
    return {
      close: "close_" + this.cargo.id,
      driver_call: this.cargo.driver_call,
      axiosConfig: {
        headers: {
          'Authorization': `Bearer ${window.localStorage.getItem("token")}`,
          'Accept': 'application/json'
        }
      }
    };
  },
  components: {
    // Detail,
    TimeCalculation
  },
  methods: {
    formatPrice(value) {
      let val = (value / 1).toFixed(0).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    getFormattedDates(date) {
      return moment(date).format("HH:mm");
    },
    roundNumber(value) {
      let val = (Math.round(value) / 1).toFixed(0).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },

    strippedUsername(to) {
      if (to.length > 20) {
        return to.slice(0, 20) + "...";
      }
      return to;
    },
  },
  setup() {
    

    const loading = ref(true);
    const map = ref();

    
    return { loading, map };

    // getDetail();
  },
};
</script>

<style scoped>
.chip.chip-media {
    position: relative;
    padding-left: 20px;
}

.chip {
    background: #E1E1E1;
    font-size: 13px;
    color: #141515;
    line-height: 1em;
    height: 26px;
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
    padding: 0;
    border-radius: 100px;
}
@import "@/assets/css/custom.css";
</style>